




import { Vue, Component, Prop } from "vue-property-decorator";
import { Statuses } from "@/data/status";

@Component
export default class StatusLabel extends Vue {
  @Prop({ required: true })
  private status!: string;

  @Prop({ required: true })
  private type!: string;

  @Prop({ required: false })
  public label!: string;

  // Data
  private statuses: any = this.$_.clone(Statuses);

  // Life-cycle methods
  public created() {
    this.$_.map(this.statuses, types => {
      return this.$_.map(types, type => {
        type.label = type.label || this.$t(`_.${type.key}`);
        return types;
      });
    });
  }

  // Computed
  public get computedStatus() {
    return (
      this.statuses[this.type][this.status] || {
        label: this.status,
        type: "is-dark"
      }
    );
  }
}
